import { CloseOutlined } from "@ant-design/icons";
import { Button, DatePicker, Form, Select, Radio, Space } from "antd";
import { useEffect, useState } from "react";
import { dictsGetPaymentVids } from '../../../extensions/dicts';
import "./rep-fin-filter.css"

const RepFinFilter = ({ current, onClose, reportTypes, onRefresh }) => {
  const [item, setItem] = useState({
    dateFrom: null,
    dateTo: null,
    cash: [],
    reportType: null,
    ...current
  });
  const [form] = Form.useForm();
  const [paymentVids, setPaymentVids] = useState([]);

  useEffect(() => { 
    form.setFieldsValue(current);
    dictsGetPaymentVids(setPaymentVids);
  }, [current]);

  const onValuesChange = (value) => {
    const updatedItem = {...item, ...value};
    setItem(updatedItem);
  }

  const onSave = () => {
    onClose(item);
    onRefresh();
  }

  const customTagRender = (props) => {
    return <span className="filters-tag-label">{props.label}</span>;
  };

  return (
    <div className="sport-modal">
      <div className="sport-modal-overlay" onMouseDown={e => e.target === e.currentTarget && onClose(false)}>
        <div className="sport-modal-content" onMouseDown={e => e.stopPropagation()}>
          <div className="sport-modal-title">
            <span>Параметры отчета</span>
            <CloseOutlined className="sport-section-title-close" onClick={() => onClose()}/>
          </div>
          <Form form={form} onValuesChange={onValuesChange} layout="inline" colon={false}>
            <Form.Item name="dateFrom" label="Период с">
                <DatePicker format="DD.MM.YYYY"/>
            </Form.Item>
            <Form.Item name="dateTo" label="по">
                <DatePicker format="DD.MM.YYYY"/>
            </Form.Item>
            <Form.Item name="cash" label="Вид оплаты">
                <Select allowClear={false} mode="multiple" options={paymentVids}
                className="filters-select" placeholder="По всем" maxTagCount={2}
                tagRender={customTagRender}/>
            </Form.Item>
            <Form.Item name="reportType">
                <Radio.Group options={reportTypes} optionType="button" buttonStyle="solid" />
            </Form.Item>
            <Form.Item>
                <Button className="sport-btn" onClick={onSave}>ОК</Button>
            </Form.Item>
        </Form>
        </div>
      </div>
    </div>
  );
}

export default RepFinFilter;
